export default "__VITE_ASSET__BHBi5DKu__"